module.exports = __webpack_public_path__ + "static/media/fal_fal_veh_pla_con.8fc6ccfd.png";